// SPDX-License-Identifier: MIT
// Persistance du sous-système plan-usage. Backend injecté (localStorage en prod
// web/desktop) → testable en mémoire. Clés sous le préfixe genesis.usage.*.
import type { PlanTier } from './usage-types';

const VALID_TIERS: readonly string[] = ['pro', 'max5', 'max20', 'unknown'];

export interface KvBackend {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

const K = {
  tier: 'genesis.usage.planTier',
  cap: 'genesis.usage.calibratedCap',
  consent: 'genesis.usage.consent',
  throttles: 'genesis.usage.throttles',
};

export interface UsageStore {
  getPlanTier(): PlanTier;
  setPlanTier(t: PlanTier): void;
  getCalibratedCap(): number | null;
  setCalibratedCap(n: number): void;
  hasConsent(): boolean;
  grantConsent(): void;
  recordThrottle(epochMs: number): void;
  throttleCountSince(sinceMs: number): number;
}

export function createUsageStore(backend: KvBackend): UsageStore {
  const readNums = (k: string): number[] => {
    try { const v = JSON.parse(backend.getItem(k) ?? '[]'); return Array.isArray(v) ? v.filter((x) => typeof x === 'number') : []; }
    catch { return []; }
  };
  return {
    getPlanTier: () => {
      const v = backend.getItem(K.tier);
      return v && VALID_TIERS.includes(v) ? (v as PlanTier) : 'unknown';
    },
    setPlanTier: (t) => backend.setItem(K.tier, t),
    getCalibratedCap: () => {
      const v = backend.getItem(K.cap);
      if (!v) return null;
      const n = Number(v);
      return Number.isFinite(n) ? n : null;
    },
    setCalibratedCap: (n) => backend.setItem(K.cap, String(n)),
    hasConsent: () => backend.getItem(K.consent) === '1',
    grantConsent: () => backend.setItem(K.consent, '1'),
    recordThrottle: (ms) => { const a = readNums(K.throttles); a.push(ms); backend.setItem(K.throttles, JSON.stringify(a)); },
    throttleCountSince: (sinceMs) => readNums(K.throttles).filter((t) => t >= sinceMs).length,
  };
}
